import { render, staticRenderFns } from "./FacebookAds.vue?vue&type=template&id=4c229daa&"
import script from "./FacebookAds.vue?vue&type=script&lang=js&"
export * from "./FacebookAds.vue?vue&type=script&lang=js&"
import style0 from "./FacebookAds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports